import { Button } from '@/atoms/Button'
import {
  AgencyListError,
  AgencyListLoading,
} from '@/modules/agencies/components/AgencyListState'
import { AgencyUsersTable } from '@/modules/agencies/components/AgencyUsersTable'
import { useAgencyUserForm } from '@/modules/agencies/hooks/useAgencyUserForm'
import { useAgencyUsers } from '@/modules/agencies/hooks/useAgencyUsers'

export type AgencyUsersSectionProps = {
  agencyId: string
}

export function AgencyUsersSection({ agencyId }: AgencyUsersSectionProps) {
  const { users, isLoading, isError, errorMessage, isEmpty } =
    useAgencyUsers(agencyId)
  const { openCreate, openEdit } = useAgencyUserForm()

  return (
    <section className="flex flex-col gap-4">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
            Users
          </h2>
          <p className="mt-1 text-sm text-muted">
            {users.length} {users.length === 1 ? 'user' : 'users'} in this agency
          </p>
        </div>
        <Button type="button" onClick={() => openCreate(agencyId)}>
          Create user
        </Button>
      </div>

      {isLoading ? <AgencyListLoading label="Loading users…" /> : null}
      {isError && errorMessage ? (
        <AgencyListError title="Could not load users" message={errorMessage} />
      ) : null}
      {!isLoading && !isError && isEmpty ? (
        <div className="border-2 border-dashed border-line bg-surface px-6 py-10 text-center">
          <p className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-muted">
            No users yet
          </p>
          <p className="mt-2 text-sm text-muted">
            Create the first user for this agency.
          </p>
          <div className="mt-5 flex justify-center">
            <Button type="button" onClick={() => openCreate(agencyId)}>
              Create user
            </Button>
          </div>
        </div>
      ) : null}
      {!isLoading && !isError && !isEmpty ? (
        <AgencyUsersTable
          users={users}
          onEditUser={(user) => openEdit(agencyId, user)}
        />
      ) : null}
    </section>
  )
}
